module.exports = __webpack_public_path__ + "img/factsheet_auto.ba8c7b1b.png";